import React, { useState, useEffect } from "react";
import classes from "./ManageUser.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { SquarePen, Trash2, Lock, Pencil } from "lucide-react";
import "react-loading-skeleton/dist/skeleton.css";
import api, { withCompanyId } from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import Swal from "sweetalert2";
import ToggleSlider from "./ToggleSlider";
import { Spinner, Badge, Button, Modal, Form, Row, Col } from "react-bootstrap";

const ManageUser = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [userPer, setUserPer] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPermisionOpenModal, setIsPermissionModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [NewUser, setNewUser] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loadingLocations, setLoadingLocations] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userPermissions, setUserPermissions] = useState({});
    const [roleStates, setRoleStates] = useState({});
    const [roles, setRoles] = useState([]);
    const [roleLoading, setRoleLoading] = useState(false);
    const [roleCheckAll, setRoleCheckAll] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);

    // NEW: Search state
    const [searchTerm, setSearchTerm] = useState("");

    const pageMap = {
        "/dashboard": "Dashboard",
        "/transactions": "Transactions",
        "/accounts": "Accounting",
        "/reports": "Reports",
        "/banking": "Banking",
        "/settings": "Settings",
    };

    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_no: "",
        address: "",
        office_address: "",
        role: "",
        profile_picture: null,
        location_id: "", // ✅ correct field
    });

    const [editformData, setEditFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_no: "",
        address: "",
        office_address: "",
        role: "",
        profile_picture: null,
        location_id: "", // ✅ correct field
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                profile_picture: file,
            }));
            setImagePreview(URL.createObjectURL(file));
        }
    };

    // 🔄 Uncomment if you need location data
    // const fetchLocations = async () => { ... };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const fd = new FormData();
            fd.append("first_name", formData.first_name);
            fd.append("last_name", formData.last_name);
            fd.append("email", formData.email);
            fd.append("phone_no", formData.phone_no);
            fd.append("address", formData.address);
            fd.append("office_address", formData.office_address);
            fd.append("role", formData.role);

            if (formData.profile_picture) {
                fd.append("profile_picture", formData.profile_picture);
            }

            fd.append("company_id", localStorage.getItem("company_id"));

            console.log("📤 Sending FormData:");
            for (let [key, value] of fd.entries()) {
                console.log(`${key}:`, value);
            }

            const response = await api.post("/v1/users/create-coop", fd, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            console.log("✅ User creation response:", response.data);

            setFormData({
                first_name: "",
                last_name: "",
                email: "",
                phone_no: "",
                role: "",
                profile_picture: null,
                address: "",
                office_address: "",
            });
            setImagePreview(null);
            setIsModalOpen(false);

            Swal.fire({
                icon: "success",
                title: "User Added",
                text: response.data.message || "User added successfully!",
                timer: 2000,
                showConfirmButton: false,
            });

            fetchNewUser();
        } catch (error) {
            console.error("❌ Error creating user:", error.response?.data || error.message);
            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Add User",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            const fd = new FormData();
            fd.append("user_id", editingUser?.id || editformData.id);
            fd.append("first_name", editformData.first_name);
            fd.append("last_name", editformData.last_name);
            fd.append("email", editformData.email);
            fd.append("phone_no", editformData.phone_no);
            fd.append("address", editformData.address);
            fd.append("office_address", editformData.office_address);
            fd.append("role", editformData.role);
            fd.append("location_id", editformData.location_id);

            // Only append profile_picture if a new file was uploaded
            if (editformData.profile_picture instanceof File) {
                fd.append("profile_picture", editformData.profile_picture);
            }

            fd.append("company_id", localStorage.getItem("company_id"));

            const res = await api.post(`/v1/users/update-user`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            Swal.fire({
                icon: "success",
                title: "User Updated",
                text: res.data?.message || "User updated successfully",
                timer: 1500,
                showConfirmButton: false,
            });

            setIsNewModalOpen(false);
            setImagePreview(null);
            fetchNewUser();
        } catch (err) {
            console.error("❌ Error updating user:", err?.response?.data || err.message);
            const errorMessage =
                typeof err.response?.data?.message === "object"
                    ? Object.values(err.response.data.message).flat().join("\n")
                    : err.response?.data?.message || "Failed to update user.";
            Swal.fire({ icon: "error", title: "Update Failed", text: errorMessage });
        } finally {
            setSubmitting(false);
        }
    };

    const handleDeleteUser = async () => {
        if (!userToDelete) return;
        setSubmitting(true);

        try {
            const payload = withCompanyId({ user_id: userToDelete.id });
            await api.post(`/v1/users/delete-user`, payload);

            setIsDeleteModalOpen(false);

            Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: `${userToDelete.name} has been removed successfully.`,
                timer: 2500,
                showConfirmButton: false,
                toast: true,
                position: 'top-end'
            });

            fetchNewUser();
            setUserToDelete(null);
        } catch (err) {
            console.error("❌ Error deleting user:", err?.response?.data || err.message);
            const errorMessage = err.response?.data?.message || "Failed to delete user.";
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const selectedRoles = roles
            .filter((item) => roleStates[item.id])
            .map((item) => item.name);

        try {
            const payload = {
                user_id: userPer?.id,
                permission: selectedRoles,
            };

            console.log("📤 Sending Payload:", payload);

            const body2 = withCompanyId(payload);
            const response = await api.post(`/v1/role/assign-permissions`, body2);

            console.log("✅ User creation response:", response.data);

            Swal.fire({
                icon: "success",
                title: "Permissions Updated",
                text: response.data.message || "Permission Updated successfully!",
                timer: 2000,
                showConfirmButton: false,
            });

            setIsPermissionModalOpen(false);
            fetchNewUser();
        } catch (error) {
            console.error("❌ Error creating user:", error.response?.data || error.message);
            console.log("❌ Error Keys:", Object.keys(error.response?.data || {}));

            const errorMessage =
                typeof error.response?.data?.message === "object"
                    ? Object.values(error.response.data.message).flat().join("\n")
                    : error.response?.data?.message || "Something went wrong.";

            Swal.fire({
                icon: "error",
                title: "Failed to Update Permissions",
                text: errorMessage,
            });
        } finally {
            setSubmitting(false);
        }
    };

    const fetchNewUser = async () => {
        try {
            const res = await api.get(`/v1/users/fetch-all`);
            const newUserData = res.data?.data?.data || res.data?.data || [];
            setNewUser(newUserData);
        } catch (err) {
            console.error("Error fetching user:", err?.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to fetch users. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            setError("Authorization token not found.");
            navigate("/signin");
            return;
        }
        fetchNewUser();
    }, [navigate]);

    const fetchRoles = async () => {
        try {
            const res = await api.get(`/v1/payroll/role`);
            const newUserData = res.data?.data?.data || res.data?.data || [];
            setRoles(newUserData);
        } catch (err) {
            console.error("Error fetching user:", err?.response?.data || err.message);
            setError(err.response?.data?.message || "Failed to fetch users. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
            setError("Authorization token not found.");
            navigate("/signin");
            return;
        }
        fetchRoles();
    }, [navigate]);

    // useEffect(() => {
    //     fetchLocations();
    // }, []);

    useEffect(() => {
        if (isModalOpen) {
            if (locations.length === 0) {
                // fetchLocations();
            }
        }
    }, [isModalOpen, locations.length]);

    const handleRoleToggleChange = (itemId) => {
        setRoleStates((prevRoleStates) => {
            const updatedStates = {
                ...prevRoleStates,
                [itemId]: !prevRoleStates[itemId],
            };

            const allChecked = roles.every((role) => updatedStates[role.id]);
            setRoleCheckAll(allChecked);

            const noneChecked = roles.every((role) => !updatedStates[role.id]);
            if (noneChecked) setRoleCheckAll(false);

            return updatedStates;
        });
    };

    const handleSelectAllChange = () => {
        const newValue = !selectAll;
        const updatedStates = {};
        roles.forEach((role) => {
            updatedStates[role.name] = newValue;
        });
        setRoleStates(updatedStates);
        setSelectAll(newValue);
    };

    const handleSelectEditChange = () => {
        const allSelected = Object.values(roleStates).every(Boolean);
        const newStates = Object.fromEntries(roles.map((role) => [role.id, !allSelected]));
        setRoleStates(newStates);
    };

    const permissionHandler = (user) => {
        console.log(user);
        setUserPer(user);
        setIsPermissionModalOpen(true);
    };

    useEffect(() => {
        if (roles.length > 0 && userPer?.permissions) {
            const userPermissionIds = userPer.permissions.map((p) => p.id);
            const initialStates = roles.reduce((acc, role) => {
                acc[role.id] = userPermissionIds.includes(role.id);
                return acc;
            }, {});
            setRoleStates(initialStates);
        }
    }, [roles, userPer]);

    const handleToggle = (permissionName) => {
        setRoleStates((prev) => ({
            ...prev,
            [permissionName]: !prev[permissionName],
        }));
    };

    const handleToggleChange = (permissionName, userId) => {
        setUserPermissions((prev) => {
            const current = prev[userId] || [];
            const updated = current.includes(permissionName)
                ? current.filter((p) => p !== permissionName)
                : [...current, permissionName];
            return { ...prev, [userId]: updated };
        });
        setRoleStates((prev) => ({
            ...prev,
            [permissionName]: !prev[permissionName],
        }));
    };

    const handleEditClick = (user) => {
        setEditingUser(user);
        setEditFormData({
            first_name: user.first_name || "",
            last_name: user.last_name || "",
            email: user.email || "",
            phone_no: user.phone_no || "",
            address: user.address || "",
            office_address: user.office_address || "",
            role: user.role?.id || "",
            profile_picture: user.profile_picture || "",
            location_id: user.location_id || "",
        });
        setImagePreview(user.profile_picture || null);

        const userPermissionNames = user.permissions?.map((p) => p.name) || [];
        const initialToggleStates = Object.fromEntries(
            roles.map((role) => [role.name, userPermissionNames.includes(role.name)])
        );
        setRoleStates(initialToggleStates);
    };

    const handleEditChange = (e) => {
        setEditFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    // Filter users based on search term
    const filteredUsers = NewUser.filter((user) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            user.name?.toLowerCase().includes(searchLower) ||
            user.email?.toLowerCase().includes(searchLower) ||
            user.phone_no?.toLowerCase().includes(searchLower)
        );
    });

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />
            <div className={classes.PgeContainerDisp}>
                <header className={classes.FrtHeaderOne}>
                    <h2 className={classes.FrtTitleOne}>Manage Users</h2>
                    <h1 className={classes.Titles}>
                        Manage your co-operative's team members, update administrative roles, and control system access.
                    </h1>
                </header>

                <div className={classes.headerforActions}>
                    <div className={classes.actionsSideRight}>
                        <div className={classes.inputWrapperTxt}>
                            <img src={searchicon} alt="Search" className={classes.inputIconGreenLrg} />
                            <input
                                type="text"
                                className={classes.searchLxtBar}
                                placeholder="Search user"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>
                    <button className={classes.btnssBtnss} onClick={() => setIsModalOpen(true)}>
                        Add User
                    </button>
                </div>

                <div className={classes.newUserCont}>
                    {/* 👇 WRAPPER FOR HORIZONTAL SCROLL ON MOBILE */}
                    <div className={classes.tableResponsiveWrapper}>
                        <table className={classes.newUserTable}>
                            <thead style={{ whiteSpace: "nowrap" }}>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone Number</th>
                                    <th>Address</th>
                                    <th className={classes.actionMove}>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading
                                    ? Array(5)
                                          .fill()
                                          .map((_, idx) => (
                                              <tr key={idx}>
                                                  {Array(6)
                                                      .fill()
                                                      .map((_, i) => (
                                                          <td key={i}>
                                                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                                                          </td>
                                                      ))}
                                              </tr>
                                          ))
                                    : filteredUsers.length === 0 ? (
                                        <tr>
                                            <td colSpan={6} style={{ textAlign: "center" }}>
                                                No User found.
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredUsers.map((user, index) => {
                                            const locationObj = locations.find(
                                                (loc) => String(loc.id) === String(user.location_id)
                                            );

                                            return (
                                                <tr key={user.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{user.name}</td>
                                                    <td>{user.email}</td>
                                                    <td>{user.phone_no}</td>
                                                    <td>{locationObj ? locationObj.location_address : "N/A"}</td>
                                                    <td className={classes.actionsEditDelete}>
                                                        <SquarePen
                                                            size={16}
                                                            className={classes.editActionIcon}
                                                            onClick={() => {
                                                                setIsNewModalOpen(true);
                                                                handleEditClick(user);
                                                            }}
                                                        />
                                                        <Trash2
                                                            size={16}
                                                            className={classes.deleteActionIcon}
                                                            onClick={() => {
                                                                setUserToDelete(user);
                                                                setIsDeleteModalOpen(true);
                                                            }}
                                                        />
                                                        <Lock
                                                            size={16}
                                                            className={classes.permissionActionIcon}
                                                            onClick={() => permissionHandler(user)}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                            </tbody>
                        </table>
                    </div>

                    <div className={classes.paginationContainertxt}>
                        <div className={classes.paginationControlstxt}>
                            <button>First</button>
                            <button className={classes.activation}>1</button>
                            <button>Last</button>
                            <span className={classes.pageDisplayText}>Displaying 1 - 41 of 41</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* **************** ADD USER MODAL **************** */}
            {isModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Add User</h2>
                            <p className={classes.modalSubTitle}>add your co-operative's team members.</p>
                        </div>
                        <hr className={classes.divider} />

                        <form onSubmit={handleSubmit}>
                            <div className={classes.modalBodyWrapper}>
                                <div className={classes.avatarSection}>
                                    <label htmlFor="profilePicture" className={classes.avatarDropZone}>
                                        <div className={classes.avatarInnerCircle}>
                                            {imagePreview ? (
                                                <img src={imagePreview} alt="Preview" className={classes.avatarImage} />
                                            ) : (
                                                <span style={{ fontSize: '40px' }}>👤</span>
                                            )}
                                            <div className={classes.avatarEditIcon}>
                                                <Pencil size={14} />
                                            </div>
                                        </div>
                                        <input id="profilePicture" type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setFormData(prev => ({ ...prev, profile_picture: file }));
                                                setImagePreview(URL.createObjectURL(file));
                                            }
                                        }} />
                                    </label>
                                </div>

                                <div className={classes.formGrid2Col}>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>First Name</label>
                                        <input type="text" name="first_name" placeholder="enter first name" className={classes.formInput} value={formData.first_name} onChange={handleChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Last Name</label>
                                        <input type="text" name="last_name" placeholder="enter last name" className={classes.formInput} value={formData.last_name} onChange={handleChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Email Address</label>
                                        <input type="email" name="email" placeholder="enter email address" className={classes.formInput} value={formData.email} onChange={handleChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Phone Number</label>
                                        <input type="tel" name="phone_no" placeholder="enter phone Number" className={classes.formInput} value={formData.phone_no} onChange={handleChange} required />
                                    </div>
                                </div>

                                <div className={classes.fullWidthSection}>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Role</label>
                                        <select name="role" className={classes.formSelect} value={formData.role} onChange={handleChange} required>
                                            <option value="">select role</option>
                                            {roles?.map((role) => (
                                                <option key={role.id} value={role.id}>{role.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Home Address</label>
                                        <textarea rows="2" name="address" placeholder="enter home address" className={classes.formTextArea} value={formData.address} onChange={handleChange} required />
                                    </div>

                        <div className={classes.formGroup}>
                            <label className={classes.formLabel}>Office Address</label>
                            <textarea rows="2" name="office_address" placeholder="enter office address" className={classes.formTextArea} value={formData.office_address} onChange={handleChange} />
                        </div>
                    </div>

                </div>

                            <div className={classes.modalFormFooter}>
                                <button type="button" className={classes.btnCancel} onClick={() => setIsModalOpen(false)}>Cancel</button>
                                <button type="submit" className={classes.btnSave} disabled={submitting}>
                                    {submitting ? "Adding..." : "Add User"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* **************** EDIT USER MODAL **************** */}
            {isNewModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2>Edit User</h2>
                            <p className={classes.modalSubTitle}>Edit your co-operative's team member details.</p>
                        </div>
                        <hr className={classes.divider} />

                        <form onSubmit={handleUpdateSubmit}>
                            <div className={classes.modalBodyWrapper}>
                                <div className={classes.avatarSection}>
                                    <label htmlFor="editProfilePicture" className={classes.avatarDropZone}>
                                        <div className={classes.avatarInnerCircle}>
                                            {imagePreview ? (
                                                <img src={imagePreview} alt="Preview" className={classes.avatarImage} />
                                            ) : (
                                                <span style={{ fontSize: '40px' }}>👤</span>
                                            )}
                                            <div className={classes.avatarEditIcon}>
                                                <Pencil size={14} />
                                            </div>
                                        </div>
                                        <input id="editProfilePicture" type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                setEditFormData(prev => ({ ...prev, profile_picture: file }));
                                                setImagePreview(URL.createObjectURL(file));
                                            }
                                        }} />
                                    </label>
                                </div>

                                <div className={classes.formGrid2Col}>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>First Name</label>
                                        <input type="text" name="first_name" placeholder="enter first name" className={classes.formInput} value={editformData.first_name} onChange={handleEditChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Last Name</label>
                                        <input type="text" name="last_name" placeholder="enter last name" className={classes.formInput} value={editformData.last_name} onChange={handleEditChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Email Address</label>
                                        <input type="email" name="email" placeholder="enter email address" className={classes.formInput} value={editformData.email} onChange={handleEditChange} required />
                                    </div>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Phone Number</label>
                                        <input type="tel" name="phone_no" placeholder="enter phone Number" className={classes.formInput} value={editformData.phone_no} onChange={handleEditChange} required />
                                    </div>
                                </div>

                                <div className={classes.fullWidthSection}>
                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Role</label>
                                        <select name="role" className={classes.formSelect} value={editformData.role} onChange={handleEditChange} required>
                                            <option value="">select role</option>
                                            {roles?.map((role) => (
                                                <option key={role.id} value={role.id}>{role.name}</option>
                                            ))}
                                        </select>
                                    </div>

                        <div className={classes.formGroup}>
                            <label className={classes.formLabel}>Home Address</label>
                            <textarea rows="2" name="address" placeholder="enter home address" className={classes.formTextArea} value={editformData.address} onChange={handleEditChange} required />
                        </div>

                                    <div className={classes.formGroup}>
                                        <label className={classes.formLabel}>Office Address</label>
                                        <textarea rows="2" name="office_address" placeholder="enter office address" className={classes.formTextArea} value={editformData.office_address} onChange={handleEditChange} />
                                    </div>
                                </div>
                            </div>

                            <div className={classes.modalFormFooter}>
                                <button type="button" className={classes.btnCancel} onClick={() => setIsNewModalOpen(false)}>Cancel</button>
                                <button type="submit" className={classes.btnSave} disabled={submitting}>
                                    {submitting ? "Updating..." : "Update User"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* **************** PERMISSION MODAL **************** */}
            {isPermisionOpenModal && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalContent}>
                        <div className={classes.modalModalHeader}>
                            <h2 style={{ marginBottom: "auto" }}>Permissions</h2>
                            <button
                                className={classes.closeModalBtn}
                                onClick={() => setIsPermissionModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className={classes.modalModalBody}>
                            <form onSubmit={handleEditSubmit}>
                                <div className={classes.modalFormFooter}>
                                    <button type="submit" className={classes.processModalBtn0} disabled={submitting}>
                                        {submitting ? "Updating..." : "Update Permissions"}
                                    </button>
                                    <button className={classes.cancelModalBtn0} onClick={() => setIsPermissionModalOpen(false)}>
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* **************** DELETE MODAL **************** */}
            {isDeleteModalOpen && (
                <div className={classes.modalModalOverlay}>
                    <div className={classes.modalModalDeleteContent}>
                        <div className={classes.modalModalHeaderDelete}>
                            <h2>Delete User</h2>
                            <button
                                className={classes.modalDeleteCloseBtn}
                                onClick={() => setIsDeleteModalOpen(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className={classes.modalDeleteBodyCenter}>
                            <div className={classes.modalDeleteIconWrapper}>
                                <div className={classes.modalDeleteIconCircle}>
                                    🗑️
                                </div>
                            </div>
                            <p className={classes.modalDeleteText}>
                                Are you sure you want to delete <strong>{userToDelete?.name}</strong>?
                            </p>
                            <p className={classes.modalDeleteSubText}>
                                This action cannot be undone.
                            </p>
                        </div>
                        <div className={classes.modalFormDelFooter}>
                            <button
                                className={classes.cancelModalBtn0}
                                onClick={() => setIsDeleteModalOpen(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className={classes.btnDeleteDanger}
                                onClick={handleDeleteUser}
                                disabled={submitting}
                            >
                                {submitting ? "Deleting..." : "Delete User"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default ManageUser;